import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { Icon, IconComponent } from '@web/shared/ui';

@Component({
  selector: 'app-multimedia-tile-box-remove-button',
  imports: [IconComponent],
  templateUrl: './multimedia-tile-box-remove-button.component.html',
  styleUrl: './multimedia-tile-box-remove-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaTileBoxRemoveButtonComponent {
  public readonly removeClickEvent = output<void>();

  protected readonly Icon = Icon;

  public handleRemoveClick(): void {
    this.removeClickEvent.emit();
  }
}
